/** @enum {string} */
export var DeviceTypeEnum;
(function (DeviceTypeEnum) {
    DeviceTypeEnum["PEN"] = "pen";
    DeviceTypeEnum["ERASER"] = "eraser";
    DeviceTypeEnum["PLAYER"] = "player";
    DeviceTypeEnum["STYLUS"] = "stylus";
    DeviceTypeEnum["FSIR"] = "fsir";
    DeviceTypeEnum["NONE"] = "none";
})(DeviceTypeEnum || (DeviceTypeEnum = {}));
/** @enum {number} */
export var PEN_STATE;
(function (PEN_STATE) {
    PEN_STATE[PEN_STATE["NONE"] = 0] = "NONE";
    PEN_STATE[PEN_STATE["PEN_DOWN"] = 1] = "PEN_DOWN";
    PEN_STATE[PEN_STATE["PEN_MOVE"] = 2] = "PEN_MOVE";
    PEN_STATE[PEN_STATE["PEN_UP"] = 9] = "PEN_UP";
    PEN_STATE[PEN_STATE["HOVER_MOVE"] = 101] = "HOVER_MOVE";
})(PEN_STATE || (PEN_STATE = {}));
export var PEN_THICKNESS;
(function (PEN_THICKNESS) {
    PEN_THICKNESS[PEN_THICKNESS["THICKNESS1"] = 0.04] = "THICKNESS1";
    PEN_THICKNESS[PEN_THICKNESS["THICKNESS2"] = 0.08] = "THICKNESS2";
    PEN_THICKNESS[PEN_THICKNESS["THICKNESS3"] = 0.12] = "THICKNESS3";
    PEN_THICKNESS[PEN_THICKNESS["THICKNESS4"] = 0.16] = "THICKNESS4";
    PEN_THICKNESS[PEN_THICKNESS["THICKNESS5"] = 0.2] = "THICKNESS5";
})(PEN_THICKNESS || (PEN_THICKNESS = {}));
/**
 *
 *
 * @export
 * @enum {number}
 */
export var PenEventName;
(function (PenEventName) {
    /**
     * stroke: NeoStroke
     * strokeKey: string
     * inputType: INeoSmartpenType,
     * mac: string
     * pen: INeoSmartPen,
     * section: number,
     * owner: number,
     * book: number,
     * page: number,
     **/
    PenEventName["ON_PEN_UP"] = "pen_up";
    /**
     * inputType: INeoSmartpenType,
     * strokeKey: string,
     * mac: string
     * stroke: NeoStroke,
     * dot: NeoDot,
     * pen: INeoSmartPen,
     * event: IPenCommEvent
     */
    PenEventName["ON_PEN_MOVE"] = "penmove";
    /**
     * inputType: INeoSmartpenType,
     * pen: INeoSmartPen,
     * mac: string,
     * event: IPenCommEvent
     */
    PenEventName["ON_HOVER_MOVE"] = "hovermove";
    /**
     * strokeKey: string
     * mac: string
     * time: number
     * stroke: NeoStroke
     * pen: INeoSmartPen,
     * inputType: INeoSmartpenType,
     */
    PenEventName["ON_PEN_DOWN"] = "pendown";
    /**
     * strokeKey: string,
     * mac: string,
     * stroke: NeoStroke,
     * section: number,
     * owner: number,
     * book: number,
     * page: number,
     * time: number
     */
    PenEventName["ON_PEN_PAGEINFO"] = "penpageinfo";
    /**
     * mac: string,
     * section: number,
     * owner: number,
     * book: number,
     * page: number,
     * time: number
     */
    PenEventName["ON_PEN_HOVER_PAGEINFO"] = "hoverpageinfo";
    /**
     * inputType: INeoSmartpenType,
     * pen: INeoSmartPen,
     * mac: string,
     * event: IPenCommEvent
     */
    PenEventName["ON_PW_REQUIRED"] = "pw_req";
    /**
     * inputType: INeoSmartpenType,
     * pen: INeoSmartPen,
     * mac: string,
     * event: IPenCommEvent
     */
    PenEventName["ON_UPGRADE_NEEDED"] = "fw_up";
    /**
     * inputType: INeoSmartpenType,
     * pen: INeoSmartPen,
     * mac: string,
     * event: IPenCommEvent
     */
    PenEventName["ON_DISCONNECTED"] = "disconnected";
    /**
     * inputType: INeoSmartpenType,
     * pen: INeoSmartPen,
     * mac: string,
     * event: IPenCommEvent
     */
    PenEventName["ON_CONNECTED"] = "connected";
    /**
     * inputType: INeoSmartpenType,
     * pen: INeoSmartPen,
     * mac: string,
     * event: IPenCommEvent
     */
    PenEventName["ON_NCODE_ERROR"] = "error";
    // ON_CALIBRATION_UP = "calibration_up",
    // ON_ERASER_MOVE = "erasermove",
    // ON_START_TO_CONNECT = "start_to_connect",
    /**
     * pen move 도중 페이지가 바뀜에 따라 생성하는 virtual event
     *
     * virual pen down/up은, 펜 스트로크가 이어지고 있음에도 페이지가 바뀌는 경우에 발생한다
     * 잉크 스토리지에는 각각의 페이지에 새로운 스트로크로 등록되도록 설계되어 있다
     *
     * 이 이벤트를 분리하는 이유는, post it 등, 아래의 종이와 겹쳐진 상태에서, 그 위치를 파악하기 위함이다
     *
     * strokeKey: string
     * mac: string
     * time: number
     * stroke: NeoStroke
     */
    PenEventName["ON_PEN_DOWN_VIRTUAL"] = "pendown_virtual";
    /**
     * pen move 도중 페이지가 바뀜에 따라 생성하는 virtual event
     *
     * stroke: NeoStroke
     * strokeKey: string
     * mac: string,
     * pen: INeoSmartPen,
     * inputType: INeoSmartpenType,
     * section: number,
     * owner: number,
     * book: number,
     * page: number,
     */
    PenEventName["ON_PEN_UP_VIRTUAL"] = "penup_virtual";
    // TODO: 확인할 것
    /**
     * ??????
     * PenManager.ts:283
     */
    PenEventName["ON_COLOR_CHANGED"] = "colorchanged";
    /**
     * 2021/06/13
     *
     * mac: string
     * pen: INeoSmartPen,
     * inputType: INeoSmartpenType,
     * writerId: string,
     */
    PenEventName["ON_WRITER_CHANGED"] = "writerchanged";
    /**
     * 2021/06/13
     *
     * mac: string
     * pen: INeoSmartPen,
     * inputType: INeoSmartpenType,
     * surfaceOwnerId: string,
     */
    PenEventName["ON_SURFACE_OWNER_CHANGED"] = "surfaceownerchanged";
    /**
     * this는 펜
     *
     * stroke: NeoStroke
     * strokeKey: string
     * inputType: INeoSmartpenType,
     * mac: string
     * pen: INeoSmartPen,
     * section: number, owner: number, book: number, page: number,
     */
    PenEventName["ON_STROKE_RECEIVED"] = "onstrokereceived";
    /**
     * 전달되는 이벤트 속성, 2021/07/05
     *
     * inputType: INeoSmartpenType,
     * puiCommand: cmd - string,
     * pen: INeoSmartPen,
     * mac: string,
     * stroke: NeoStroke
     */
    PenEventName["ON_PUI_COMMAND"] = "onpuitouched";
    /**
     * 2021/08/18
     * 펜 상태 정보 수신 시
     */
    PenEventName["ON_PEN_STATUS_RESPONSE"] = "pen_status";
})(PenEventName || (PenEventName = {}));
export var IBrushType;
(function (IBrushType) {
    IBrushType[IBrushType["PEN"] = 0] = "PEN";
    IBrushType[IBrushType["ERASER"] = 1] = "ERASER";
    IBrushType[IBrushType["MARKER"] = 2] = "MARKER";
    IBrushType[IBrushType["PENCIL"] = 3] = "PENCIL";
    IBrushType[IBrushType["BRUSH"] = 4] = "BRUSH";
    IBrushType[IBrushType["FOUNTAINPEN"] = 5] = "FOUNTAINPEN";
    IBrushType[IBrushType["PUI"] = 8] = "PUI";
    IBrushType[IBrushType["ERASED"] = 9] = "ERASED";
})(IBrushType || (IBrushType = {}));
//# sourceMappingURL=PenEnums.js.map